
export default {
    INIT_SCREEN_RESIZE: "initScreenResize",//初始化窗口变化分发事件
    SUB_SCREEN_RESIZE: "subScreenReSize",//全局窗口变化订阅事件
    SCENE_INIT_PROGRESS: "sceneInitProgress",//系统初始化进度
    SETGASSTORE: "setGasStore",//设置此次气体池
    SETGASLOG: "setGasLog",//实验记录
    CLEARGASLOG: "clearGasLog",
    SETLOGIN: "setLogin",//记录学号信息
    SETCONFIG: "setConfig",//存放配置
}
